// ----------------------------------------------------------
// IMPORTS
// ----------------------------------------------------------
import EgoForm from '@egodesign/form'
import EgoModal from '@egodesign/modal'
import { formContact } from '../components/form-contact'

// ----------------------------------------------------------
// MODULES
// Helper functions
// ----------------------------------------------------------
import { getParentWithProductData, removeAllSparePartItems, updateCartItems } from '../modules/tools'

// ----------------------------------------------------------
// STORE
// Instance of Zustand Store
// ----------------------------------------------------------
import store from '../../../state/store'
import { sparePartGTM } from '../modules/marketing/gtm'
import { metaLead } from '../modules/marketing/meta-api'
import { getCSRFTokenValue, getRecaptchaToken } from '../modules/form-helpers'

// Getters and setters from the store
const { addToCart, removeFromCart, getCartProducts, removeOneItemFromCart, removeAllItemsFromCart } = store.getState()

// ----------------------------------------------------------
// SELECTORS
// ----------------------------------------------------------
const form = document.querySelector('#checkoutSteppedForm')
const checkout_grid = document.querySelector('.checkout__grid')

// ----------------------------------------------------------
// GLOBALS
// ----------------------------------------------------------
window.addQtyHandler = function (event) {
    const targetElement = getParentWithProductData(event.currentTarget)

    if (targetElement === null) {
        console.error("No parent element with 'data-product' found.")
        return
    }

    // STATE CHANGE
    addToCart(targetElement.dataset.product)

    // UI CHANGE
    updateCartItems()
}

window.removeItemHandler = function (event) {
    const targetElement = getParentWithProductData(event.currentTarget)

    // STATE CHANGE
    removeFromCart(targetElement.dataset.product)

    // UI CHANGE
    updateCartItems()
    let cart_products = getCartProducts()

    if (!cart_products.length > 0) {
        console.log('no cart itms')
        checkout_grid.classList.add('--no-detail')
    }
}

window.minusItemHandler = function (event) {
    const targetElement = getParentWithProductData(event.currentTarget)

    // STATE CHANGE
    removeOneItemFromCart(targetElement.dataset.product)

    // UI CHANGE
    updateCartItems()
}

window.addEventListener('load', (e) => {
    // ----------------------------------------------------------
    // SETUP
    // 1) Initialize the form
    // ----------------------------------------------------------

    // Definimos la función para actualizar el contador
    function updateCounter(seconds, counterElement) {
        if (seconds === 1) {
            counterElement.textContent = `${seconds} segundo` // Actualizamos el contenido del elemento
        } else {
            counterElement.textContent = `${seconds} segundos` // Actualizamos el contenido del elemento
        }
    }

    if (form) {
        let modalError, retrySubmitBtn, successModal, countdownInterval

        const modalErrorNode = document.querySelector('#modal-quotation-error')
        if (modalErrorNode) {
            modalError = new EgoModal({
                element: modalErrorNode,
                onClose: () => clearInterval(countdownInterval),
            })
            retrySubmitBtn = modalErrorNode?.querySelector('.btn-retry-submit')
            const btnSubmit = form.querySelector("button[type='submit']")
            retrySubmitBtn.addEventListener('click', () => {
                modalError.close()
                setTimeout(() => {
                    btnSubmit.click() // Vuelve a mandar la solicitud
                }, 1000)
            })
            modalErrorNode.querySelector('.modal-close')?.addEventListener('click', () => {
                modalError.close()
            })
        }

        const successModalNode = document.querySelector('#modal-quotation-success')
        if (successModalNode) {
            successModal = new EgoModal({
                element: successModalNode,
            })
        }

        // Coundown Node
        const counterElement = modalErrorNode?.querySelector('.modal-counter-sec')
        const csrf = getCSRFTokenValue(form)

        const checkoutSteppedForm = new EgoForm({
            element: form,
            submitType: 'fetch',
            requestHeaders: {
                'X-CSRFToken': csrf,
            },
            customValidationMessages: {
                default: {
                    empty: 'Campo requerido.',
                    invalid: 'Campo nó válido.',
                    minLength: 'Min. [[var]] caracteres.',
                    maxLength: 'Máx. [[var]] caracteres.',
                },
                categories: {
                    empty: 'Seleccioná al menos una opción',
                },
                actions: {
                    empty: 'Seleccioná al menos una opción',
                },
                cuit: {
                    empty: 'Campo requerido.',
                    invalid: 'Revisá este CUIT',
                },
                cuit_cuil: {
                    empty: 'Campo requerido.',
                    invalid: 'Revisá este CUIT',
                },
            },
            customValidations: {
                phone_sum: [
                    {
                        name: 'phone_sum',
                        condition: (value) => {
                            const codeAreaVal = form.querySelector('#contactAreaInput')?.value
                            return value.length + codeAreaVal.length === 10
                        },
                        message: 'Revisá este número y el código de área',
                    },
                ],
                cuit_cuil: [
                    {
                        name: 'cuit_cuil',
                        condition: (cuit) => {
                            if (cuit.length < 11 || cuit.length > 13) return false;
                            let rv = false;
                            let resultado = 0;
                            let cuit_nro = cuit.replace("-", "");
                            const codes = "6789456789";
                            let verificador = parseInt(cuit_nro[cuit_nro.length - 1]);
                            let x = 0;

                            while (x < 10) {
                                let digitoValidador = parseInt(codes.substring(x, x + 1));
                                if (isNaN(digitoValidador)) digitoValidador = 0;
                                let digito = parseInt(cuit_nro.substring(x, x + 1));
                                if (isNaN(digito)) digito = 0;
                                let digitoValidacion = digitoValidador * digito;
                                resultado += digitoValidacion;
                                x++;
                            }
                            resultado = resultado % 11;
                            rv = (resultado == verificador);
                            return rv;
                        },
                        message: 'Revisá este número y el código de área',
                    },
                ],
            },
            onValidationError: (errorFieldsNames) => {
                // Errores en el último paso (onValidationError se dispara al momento del submit)
                sparePartGTM({
                    element: form,
                    action: 'error',
                    step: 3,
                    validationError: errorFieldsNames,
                })
            },
            onStepChange: (prev, next) => {
                const prevEl = form.querySelector(`.steps__item[data-number="${prev}"]`)
                prevEl.classList.remove('--active')
                if (prev < next) prevEl.classList.add('--validated')

                const nextEl = form.querySelector(`.steps__item[data-number="${next}"]`)
                nextEl.classList.add('--active')
                if (prev < next) {
                    nextEl.classList.remove('--validated')
                    const curr = prevEl.dataset.number
                    // TODO: DataLayer de cada paso completado. El último se envía en onSuccess
                    sparePartGTM({
                        element: form,
                        action: 'changed step',
                        step: parseInt(curr),
                    })
                }
            },
            onSuccess: (res) => {
                if (modalErrorNode.classList.contains('--open')) modalError.close()
                successModal.open()

                removeAllItemsFromCart()

                sparePartGTM({
                    element: form,
                    action: 'changed step',
                    step: 3, // último paso
                })
                sparePartGTM({
                    element: form,
                    action: 'success',
                })

                res.json().then(({ data }) => {
                    metaLead(data)
                })
            },
            onError: () => {
                // Deshabilitamos el botón de reintentar
                retrySubmitBtn.classList.add('--disabled')

                // Iniciamos el contador
                counterElement.parentElement.style.display = 'unset'
                let secondsLeft = 5
                updateCounter(secondsLeft, counterElement)

                // Creamos un intervalo que se ejecutará cada segundo
                countdownInterval = setInterval(() => {
                    secondsLeft-- // Restamos un segundo
                    updateCounter(secondsLeft, counterElement) // Actualizamos el contador

                    if (secondsLeft === 0) {
                        clearInterval(countdownInterval) // Detenemos el intervalo cuando llegamos a cero
                        // Ocultamos el countdown
                        counterElement.parentElement.style.display = 'none'
                        // Habilitamos en botón de reintentar
                        retrySubmitBtn.classList.remove('--disabled')
                    }
                }, 1000)

                // Abrimos el modal si aún no está abierto
                if (!modalErrorNode.classList.contains('--open')) modalError.open()

                sparePartGTM({
                    element: form,
                    action: 'error',
                })
            },
            onSubmitStart: () => {
                // Convierte el carrito de los productos de repuestos en un mensaje
                const products = getCartProducts()
                if (products.length) {
                    const productsSelectedInput = form.querySelector('#products-selected')
                    const productsShortData = products.map((product) => ({
                        name: product.name?.trim(),
                        code: product.code?.trim(),
                        quantity: product.quantity,
                    }))
                    productsSelectedInput.value = JSON.stringify(productsShortData)
                }
            },
            onBeforeSubmit: async () => {
                checkoutSteppedForm.submittingForm(true);
                const recaptchaToken = await getRecaptchaToken();
                if (recaptchaToken) {
                    checkoutSteppedForm.extraFields.push({
                        name: 'recaptcha_token',
                        value: recaptchaToken
                    })
                    checkoutSteppedForm.resumeSubmit();
                } else {
                    checkoutSteppedForm.submittingForm(false);
                    checkoutSteppedForm.onError();
                }
            },
            preventSubmit: true,
        })

        // Para verificar campos con errores de validación:
        const nextButtons = form.querySelectorAll('.form__next-step')
        nextButtons.forEach((nextBtn) => {
            nextBtn.addEventListener('click', () => {
                setTimeout(() => {
                    const fieldsWithErrors = form.querySelectorAll('.form__field.--has-error')
                    if (!fieldsWithErrors.length) return

                    const currentStep = form.querySelector(`.steps__item.--active`)?.dataset.number
                    const invalidFields = []
                    fieldsWithErrors.forEach((field) => {
                        invalidFields.push(field.querySelector('.form__control')?.name)
                    })

                    sparePartGTM({
                        element: form,
                        action: 'error',
                        step: parseInt(currentStep),
                        validationError: invalidFields,
                    })
                }, 200)
            })
        })

        // muestro o mensaje de alerta en el campo de Telefono
        const selectLineType = form.querySelector('#contactLineInput')
        if (selectLineType) {
            selectLineType.addEventListener('change', (e) => {
                // limpia número de teléfono
                const phoneNumberInput = form.querySelector('#contactPhoneInput')
                phoneNumberInput.value = ''

                const alert = form.querySelector('#contactPhoneInputAlert')
                const internField = form.querySelector('#contactInternInput')

                if (e.target.value == 'movil') {
                    alert.style.display = 'block'
                    internField.disabled = true
                    internField.value = ''
                    internField.parentElement.classList.remove('--filled')
                } else {
                    alert.style.display = 'none'
                    internField.disabled = false
                }
            })
        }

        document.querySelectorAll('.no-leading-zero')?.forEach((input) => {
            input.addEventListener('input', (e) => {
                if (e.target.value?.toString().charAt(0) === '0') {
                    const alert = input.parentElement.querySelector('.form__alert')
                    if (alert) {
                        alert.classList.remove('--hidden')
                    }
                }
                input.value = input.value.replace(/\b0+/g, '')
            })
            input.addEventListener('paste', () => {
                input.value = input.value.replace(/\b0+/g, '')
            })
        })

        document.querySelectorAll('.no-leading-15')?.forEach((input) => {
            input.addEventListener('input', (e) => {
                if (selectLineType?.value === 'movil') {
                    const val = e.target.value?.toString()
                    if (val.length > 1 && val.charAt(0) === '1' && val.charAt(1) === '5') {
                        const alert = input.parentElement.querySelector('.form__alert')
                        if (alert) {
                            alert.classList.remove('--hidden')
                        }
                    }
                    input.value = input.value.replace(/\b15+/g, '')
                }
            })
            input.addEventListener('paste', () => {
                if (selectLineType?.value === 'movil') {
                    const val = e.target.value?.toString()
                    if (val.length > 1 && val.charAt(0) === '1' && val.charAt(1) === '5') {
                        const alert = input.parentElement.querySelector('.form__alert')
                        if (alert) {
                            alert.classList.remove('--hidden')
                        }
                    }
                    input.value = input.value.replace(/\b15+/g, '')
                }
            })
        })
    }

    // ----------------------------------------------------------
    // 2) Render the products in the cart
    // ----------------------------------------------------------
    let cart_products = getCartProducts()

    if (cart_products.length > 0) {
        updateCartItems()
    } else {
        checkout_grid.classList.add('--no-detail')
    }
})

formContact()
removeAllSparePartItems(checkout_grid)
